export const Complete = {
  ServiceTilePrefix: 'service-tile',
  ServiceTileBtnPrefix: 'service-tile-btn',
} as const;
